import { SplitContentConfigRendererDynamicTemplate } from "./SplitContentConfigRendererDynamicTemplate";
import { SplitContentNodeContent } from "../splitContentTypes";
import { SplitContentConfigRendererContentGroup } from "./SplitContentConfigRendererContentGroup";
import { SplitContentConfigRendererChannel } from "./SplitContentConfigRendererChannel";

interface Props {
  node: SplitContentNodeContent;
}

export const SplitContentConfigRenderer: React.FC<Props> = ({ node }) => {
  if (!node || !node.type || !node.config) {
    return null;
  }

  const { type, config } = node;
  if (type !== "content") {
    return null;
  }

  const attachConfigType = config.type;

  if (attachConfigType === "content") {
    const { contentType, src } = config;
    if (contentType?.startsWith("image")) {
      return <img src={src} alt="content" className="object-contain w-full h-full" />;
    }
    return <video src={src} muted autoPlay controls={false} loop className="w-full h-full" />;
  }

  if (attachConfigType === "html") {
    return <div dangerouslySetInnerHTML={{ __html: config.html }} />;
  }

  if (attachConfigType === "url") {
    return <iframe src={config.url} name="myiFrame" width="100%" height="100%" allowFullScreen></iframe>;
  }

  if (attachConfigType === "dynamic-template") {
    return <SplitContentConfigRendererDynamicTemplate config={config} />;
  }

  if (attachConfigType === "content-group") {
    return <SplitContentConfigRendererContentGroup config={config} />;
  }

  if (attachConfigType === "channel") {
    return <SplitContentConfigRendererChannel config={config} />;
  }

  return <div>{JSON.stringify(node)}</div>;
};
